import { render, staticRenderFns } from "./SliderHeader.vue?vue&type=template&id=4a1fec70"
import script from "./SliderHeader.vue?vue&type=script&lang=js"
export * from "./SliderHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports